import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toggleLoader} from 'app/redux/loaderSlice'
import {showMessage} from 'app/redux/messageSlice'
import deliveryMethodService from 'app/services/DeliveryMethodService'

export const getDeliveryMethods = createAsyncThunk(
  'vino/deliveryMethods/list',
  async (model: any, {dispatch, rejectWithValue}: any) => {
    try {
      dispatch(toggleLoader(true))
      const deliveryMethods = await deliveryMethodService.list(mapToRateParam(model))
      return deliveryMethods
    } catch (err) {
      console.error(err)
      dispatch(
        showMessage({
          message: 'Error occurred while getting shipping methods',
          variant: 'error',
        })
      )
      return rejectWithValue(err)
    } finally {
      dispatch(toggleLoader(false))
    }
  }
)

export const getDeliveryMethods2 = createAsyncThunk(
  'vino/deliveryMethods/list',
  async (model: any, {dispatch, rejectWithValue}: any) => {
    try {
      dispatch(setIsFetching(true))
      const deliveryMethods = await deliveryMethodService.list(mapToRateParam2(model))
      return deliveryMethods
    } catch (err) {
      console.error(err)
      dispatch(
        showMessage({
          message: 'Error occurred while getting shipping methods',
          variant: 'error',
        })
      )
      return rejectWithValue(err)
    } finally {
      dispatch(setIsFetching(false))
    }
  }
)

type State = {
  rates: any[]
  noRates?: boolean
  isFetching: boolean
}

const initialState: State = {
  isFetching: false,
  rates: [],
}

const deliveryMethodsSlice = createSlice({
  name: 'vino/deliveryMethods',
  initialState,
  reducers: {
    setIsFetching: (state, action) => {
      state.isFetching = action.payload
    },
    resetDeliveryMethods: (state) => {
      return initialState
    },
  },
  extraReducers: {
    [getDeliveryMethods.fulfilled.toString()]: (state, action) => {
      state.rates = action.payload
      state.noRates = action.payload.length === 0
    },

    [getDeliveryMethods2.fulfilled.toString()]: (state, action) => {
      state.rates = action.payload
      state.noRates = action.payload.length === 0
    },
  },
})

export const {setIsFetching, resetDeliveryMethods} = deliveryMethodsSlice.actions

export default deliveryMethodsSlice.reducer

const mapToRateParam = (model: any) => {
  const {totalWeight, order} = model
  const {
    shippingAddress: {country, state, zipCode},
  } = order
  return {
    shippingAddress: {
      countryCode: country.code,
      postalCode: zipCode,
      stateOrProvinceCode: state.code,
    },
    weight: {
      value: parseFloat(totalWeight),
      units: 'LB',
    },
    all: true,
  }
}

const mapToRateParam2 = (model: any) => {
  const {totalWeight, order} = model
  const {country, state, zipCode} = order
  return {
    shippingAddress: {
      countryCode: country,
      postalCode: zipCode,
      stateOrProvinceCode: state,
    },
    weight: {
      value: parseFloat(totalWeight),
      units: 'LB',
    },
    all: true,
  }
}
